import styled from 'styled-components';

export const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.palette.dark[50]};
`;
